import { useCallback, useEffect, useState } from "react";
import { useSnackbar } from "../../../components/Snackbar";
import {
  getWorkspaces,
  WorkspaceFilterBy,
} from "../../../apis/bacchus/workspace";
import { Workspace } from "../../../types/workspace";

export function useGetWorkspaces(filterBy: WorkspaceFilterBy) {
  const { showError } = useSnackbar();

  const [workspaces, setWorkspaces] = useState<Workspace[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadWorkspaces = useCallback(async () => {
    setIsLoading(true);

    const { data: workspaces, error } = await getWorkspaces(filterBy);

    if (error) {
      showError(error.message);
    } else {
      setWorkspaces(workspaces ?? []);
    }

    setIsLoading(false);
  }, [filterBy, showError]);

  useEffect(() => {
    loadWorkspaces();
  }, [loadWorkspaces]);

  return {
    workspaces,
    isLoading,
    loadWorkspaces,
  };
}
